import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent } from '@icms/core/content';
import { AbstractCmsBlockComponent } from '../../block/abstract-cms-block.component';
import { CMS_COMPONENT_OUTLET_BLOCK_CONFIG } from './cms-outlet-block.config';
import { NCmsOutletBlock } from './cms-outlet-block.interface';

@Component({
    selector: 'cms-outlet-block',
    templateUrl: './cms-outlet-block.component.html',
    styleUrl: './cms-outlet-block.component.scss',
    standalone: true,
    imports: [ICmsClientModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<CmsOutletBlockComponent>(CMS_COMPONENT_OUTLET_BLOCK_CONFIG)
export class CmsOutletBlockComponent extends AbstractCmsBlockComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'blockContent'
    })
    override content!: NCmsOutletBlock.IBlockDataContent;

    /**
     * Components identifiers list, extends default components list by requested ones here even if they are on demand only
     */
    @Input()
    allow?: string[];

    /**
     * Components identifiers list, restricts the list to these components only
     */
    @Input()
    allowOnly?: string[];

    /**
     * Components identifiers list, disallows listed components
     */
    @Input()
    disallow?: string[];

    /**
     * Main component will be a target for component adding
     * without a need to select it
     */
    @Input()
    main = false;

    /**
     * Outlet description used in icms
     */
    @Input()
    name?: string;
}
